import React from "react";
import { Button, Card } from "components/atoms";
import { PersonCircleIcon, LinkedInIcon } from "assets/icons";
import TeamData from "assets/json/Team.json";
import joelImage from "assets/images/Team/joel_square.jpg";
import simonImage from "assets/images/Team/simon_square.jpg";
import "./TeamPage.scss";

interface TeamMember {
  id: string;
  name: string;
  position: string;
  description: string;
  funFact?: string;
  imageRef: string;
  linkedIn: string;
}

const imageMap: { [key: string]: string } = {
  joelImage,
  simonImage,
};

const mappedTeamData: TeamMember[] = TeamData.map((member) => ({
  ...member,
  imageRef: imageMap[member.imageRef],
}));

const TeamPage: React.FC = () => {
  const toLinkedInPage = (linkedInURL: string) => {
    window.open(linkedInURL, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="team-page">
      <h2 className="team-title text-center p-4 my-4">Meet the Team</h2>
      <div className="row our-team-row">
        {mappedTeamData.map((member: TeamMember) => (
          <div className="col-12 col-md-6 col-lg-4" key={member.id}>
            <div className="team-member-card">
              {member.imageRef ? (
                <div className="team-member-image">
                  <img
                    src={member.imageRef}
                    alt={`${member.name}`}
                    className={`${member.name}-image`}
                  />
                </div>
              ) : (
                <div className="team-member-icon">
                  <PersonCircleIcon />
                </div>
              )}

              <Card
                title={member.name}
                description={
                  <>
                    <p className="team-member-position">{member.position}</p>
                    <div className="linkedIn">
                      <Button
                        type="button"
                        className="team-member-button"
                        text={<LinkedInIcon />}
                        onClick={() => toLinkedInPage(member.linkedIn)}
                        variant="borderless"
                      />
                    </div>
                    <p className="team-member-description">
                      {member.description}
                    </p>
                    {/* Uncomment if you want to show fun fact */}
                    {member.funFact && (
                      <p className="team-member-fun-fact">
                        <strong>Fun Fact:</strong> {member.funFact}
                      </p>
                    )}
                  </>
                }
                className="team-member-card-content"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamPage;
